import React, {useEffect} from 'react';
import {matchPath, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {Button} from "primereact/button";
import {menuConfig} from "../../../redux/config";
import {ProgressBar} from "primereact/progressbar";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import {setPendingRedirectPath} from "../../../redux/actions/actionsUser";
import {getEventStatisticToUserDetail} from "../../../redux/api/apiStatisticsList";
import StatisticsListDetails from "../../Statistics/StatisticsList/StatisticsListDetails";

const MonitoringDetailsWindow = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    // @ts-ignore
    const activeClick = useAppSelector(state => state.UsersListReducer.activeClick);
    const monitoringData = useAppSelector(state => state.StatisticsListReducer?.statisticData);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const detailsLoading = useAppSelector(state => state.StatisticsListReducer.detailsLoading);
    const monitoringPermissions = checkPermissions(rolesVision, 'Monitoring');
    const statisticPermissions = checkPermissions(rolesVision, 'Statistic');

    useEffect(() => {
        const cleanPath = activeClick?.from?.replace(/^#/, '');
        if (cleanPath && matchPath("/call_details/:id", cleanPath)) {
            dispatch(getEventStatisticToUserDetail(id, jwtToken?.jwtToken));
            dispatch(setPendingRedirectPath(null));
        }
    }, [activeClick]);

    useEffect(() => {
        dispatch(setPendingRedirectPath(null));
    }, []);

    useEffect(() => {
        if (!id || isNaN(Number(id))) {
            return;
        } else {
            dispatch(getEventStatisticToUserDetail(id, jwtToken?.jwtToken));
        }
    }, [id]);

    const navigateToMainPage = () => {
        const filteredMenuConfigWithRole = menuConfig.filter((item) =>
            rolesVision.hasOwnProperty(item.name)
        );
        if (filteredMenuConfigWithRole.length) {
            const order = rolesVision ? Object.keys(rolesVision) : [];

            filteredMenuConfigWithRole?.sort((a, b) => {
                const indexA = order?.indexOf(a.name);
                const indexB = order?.indexOf(b.name);
                return indexA - indexB;
            });

            if (filteredMenuConfigWithRole[0].name.toLowerCase() === 'dialer') {
                navigate(`/`);
                window.location.reload();
            } else {
                navigate(`/${filteredMenuConfigWithRole[0].name.toLowerCase()}`);
                window.location.reload();
            }
        }
    }

    return (
        (statisticPermissions || monitoringPermissions) ? (
            <div className="card">
                {detailsLoading ? (
                    <ProgressBar mode="indeterminate" style={{ height: '6px' }} />
                ) : monitoringData?.id ? (
                    <StatisticsListDetails isWindow={true} />
                ) : (
                    <div className="flex justify-content-center flex-wrap">
                        <div>
                            <h5 className="block flex align-items-center m-0 font-medium">
                                <i className="pi pi-info-circle mr-4" style={{ color: 'red', fontSize: '2.5rem' }}></i>
                                Деталі дзвінка не знайдені. Перевірте посилання або спробуйте ще раз
                            </h5>
                        </div>
                        <div className="flex justify-content-center w-full mt-3">
                            <Button label="Головна сторінка" onClick={navigateToMainPage} />
                        </div>
                    </div>
                )}
            </div>
        ) : (
            <div className="card">
                <div className="flex justify-content-center flex-wrap">
                    <div>
                        <h5 className="block flex align-items-center m-0 font-medium">
                            <i className="pi pi-info-circle mr-4" style={{ color: 'red', fontSize: '2.5rem' }}></i>
                            Заборонено для вашої ролі.
                        </h5>
                    </div>
                    <div className="flex justify-content-center w-full mt-3">
                        <Button label="Головна сторінка" onClick={navigateToMainPage} />
                    </div>
                </div>
            </div>
        )
    );
};

export default MonitoringDetailsWindow;
